module.exports = __webpack_public_path__ + "images/arrow-line-yellow-06aa13acff8ce217f7bbf104878dea22.png";